import { createApp } from "vue";
import App from "./App.vue";
import { registerPlugins } from "@utils/plugins";

import { createRoot } from "react-dom/client";
import { setVeauryOptions } from "veaury";
import { registerSW } from "virtual:pwa-register";

// import "vuetify/styles";
import "@styles/tailwind.css";
import "@styles/styles.scss";

setVeauryOptions({
  react: {
    createRoot,
  },
});

// Create vue app
const app = createApp(App);

// Register plugins
registerPlugins(app);

// Mount vue app
app.mount("#app");

if (import.meta.env.PROD) {
  registerSW({ immediate: true });
}
